import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import useResponsiveObserver from "antd/es/_util/responsiveObserver";
import AntCheckbox from "antd/es/checkbox";
import modelFallback from "../../assets/images/modelFallback.svg.js";
import useMergePropByScreen from "../../hooks/useMergePropByScreen.js";
import classnames from "../../utils/classnames.js";
import Checkbox from "../Checkbox/Checkbox.js";
import Col from "../Grid/Col.js";
import Row from "../Grid/Row.js";
import './ModelCheckbox.css';import '../Grid/Grid.css';/* empty css                */
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import ModelCheckboxSkeleton from "./ModelCheckboxSkeleton.js";
/* empty css                   */
const ModelCheckbox = ({
  id,
  model,
  className,
  style,
  onChange,
  onClick,
  onKeyPress,
  onKeyDown,
  onMouseEnter,
  onMouseLeave,
  onCheckboxChange,
  onCheckboxClick,
  onCheckboxKeyPress,
  onCheckboxKeyDown,
  onCheckboxMouseEnter,
  onCheckboxMouseLeave,
  isLoading,
  type = "primary",
  checkboxLayout = "checkbox",
  layout = "full",
  hasPrice = true,
  extra = "",
  ...props
}) => {
  const { name, count = null, price, description, imgSrc, imgSrcSet, imgSizes, imgAlt } = model;
  const isFullLayout = layout === "full";
  const isCheckboxLayout = checkboxLayout === "checkbox";
  const isDirectionRow = !hasPrice && !description && !extra;
  if (isLoading) {
    return /* @__PURE__ */ jsx(ModelCheckboxSkeleton, { type, layout, style });
  }
  return /* @__PURE__ */ jsx(
    AntCheckbox,
    {
      id,
      className: classnames(
        ["perxis-auto-model-checkbox", `perxis-auto-model-checkbox--${layout}`, `perxis-auto-model-checkbox--${type}`],
        className
      ),
      onChange,
      onClick,
      onKeyPress,
      onKeyDown,
      onMouseEnter,
      onMouseLeave,
      style,
      ...props,
      children: /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-model-checkbox__wrapper"), children: [
        count !== null && /* @__PURE__ */ jsx(Typography.Text, { level: "marker", color: "dark", className: classnames("perxis-auto-model-checkbox__count"), children: count }),
        /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-model-checkbox__image-wrapper"), children: /* @__PURE__ */ jsx(
          "img",
          {
            alt: imgAlt,
            src: imgSrc || modelFallback,
            srcSet: imgSrcSet,
            sizes: imgSizes,
            onError: ({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = modelFallback;
              currentTarget.srcset = "";
            },
            className: classnames("perxis-auto-model-checkbox__image")
          }
        ) }),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classnames([
              "perxis-auto-model-checkbox__content",
              {
                "perxis-auto-model-checkbox__content-direction-row": isDirectionRow
              }
            ]),
            children: [
              /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-model-checkbox__name-wrapper"), children: [
                /* @__PURE__ */ jsx(Typography.Text, { level: "h3", color: "darkest", className: classnames("perxis-auto-model-checkbox__name"), children: name }),
                !!description && /* @__PURE__ */ jsx(
                  Typography.Text,
                  {
                    level: "small",
                    color: "dark-light",
                    className: classnames("perxis-auto-model-checkbox__description"),
                    children: description
                  }
                )
              ] }),
              hasPrice ? /* @__PURE__ */ jsxs(
                Row,
                {
                  wrap: false,
                  align: isFullLayout ? "bottom" : "middle",
                  gutter: [8, 0],
                  className: classnames("perxis-auto-model-checkbox__price-wrapper"),
                  children: [
                    /* @__PURE__ */ jsxs(Col, { flex: "auto", children: [
                      /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "darkest", className: classnames("perxis-auto-model-checkbox__price"), children: price }),
                      !!extra && /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(
                        Typography.Text,
                        {
                          level: "super-small",
                          color: "dark-light",
                          className: classnames("perxis-auto-model-checkbox__extra"),
                          children: extra
                        }
                      ) }) })
                    ] }),
                    /* @__PURE__ */ jsx(Col, { flex: "none", className: classnames("perxis-auto-model-checkbox__check"), children: isCheckboxLayout ? /* @__PURE__ */ jsx(
                      Checkbox,
                      {
                        onChange: onCheckboxChange,
                        onClick: onCheckboxClick,
                        onKeyPress: onCheckboxKeyPress,
                        onKeyDown: onCheckboxKeyDown,
                        onMouseEnter: onCheckboxMouseEnter,
                        onMouseLeave: onCheckboxMouseLeave,
                        className: classnames("perxis-auto-model-checkbox__checkbox"),
                        ...props
                      }
                    ) : /* @__PURE__ */ jsx(Icon, { name: "check", className: classnames("perxis-auto-model-checkbox__check-icon") }) })
                  ]
                }
              ) : /* @__PURE__ */ jsx(Row, { justify: "space-between", children: /* @__PURE__ */ jsxs(Col, { flex: "auto", className: classnames("perxis-auto-model-checkbox__check-without-price"), children: [
                !!extra && /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(
                  Typography.Text,
                  {
                    level: "super-small",
                    color: "dark-light",
                    className: classnames("perxis-auto-model-checkbox__extra"),
                    children: extra
                  }
                ) }) }),
                isCheckboxLayout ? /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    onChange: onCheckboxChange,
                    onClick: onCheckboxClick,
                    onKeyPress: onCheckboxKeyPress,
                    onKeyDown: onCheckboxKeyDown,
                    onMouseEnter: onCheckboxMouseEnter,
                    onMouseLeave: onCheckboxMouseLeave,
                    className: classnames("perxis-auto-model-checkbox__checkbox"),
                    ...props
                  }
                ) : /* @__PURE__ */ jsx(Icon, { name: "check", className: classnames("perxis-auto-model-checkbox__check-icon") })
              ] }) })
            ]
          }
        )
      ] })
    }
  );
};
const Group = ({
  className,
  flex,
  span,
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  type,
  checkboxLayout,
  isLoading,
  options = [],
  layout = "full",
  hasPrice = true,
  extra = "",
  gutter = [8, "vertical-sky"],
  ...props
}) => {
  const [curScreens, setCurScreens] = useState({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false
  });
  const responsiveObserver = useResponsiveObserver();
  useEffect(() => {
    const token = responsiveObserver.subscribe((screen) => {
      setCurScreens(screen);
    });
    return () => responsiveObserver.unsubscribe(token);
  }, []);
  const curLayout = useMergePropByScreen("full", layout, curScreens);
  return /* @__PURE__ */ jsx(AntCheckbox.Group, { className: classnames("perxis-auto-model-checkbox-group", className), ...props, children: /* @__PURE__ */ jsx(Row, { gutter, children: options.map((option) => /* @__PURE__ */ jsx(Col, { flex, span, xs, sm, md, lg, xl, xxl, children: /* @__PURE__ */ jsx(
    ModelCheckbox,
    {
      title: option.model.name,
      checkboxLayout,
      layout: curLayout,
      type,
      hasPrice,
      extra,
      isLoading,
      ...option
    },
    option.value
  ) }, option.value)) }) });
};
ModelCheckbox.Group = Group;
export {
  ModelCheckbox as default
};
//# sourceMappingURL=ModelCheckbox.js.map
